import React from 'react';
import { createPortal } from 'react-dom';
import { coLearningPromptBackdropProps } from './coLearningModalTheme';

/**
 * Full-viewport modal backdrop (portaled to document.body).
 * Needed because parent shells use overflow/transform/backdrop-filter, which trap `position: fixed`.
 */
export default function CoLearningPromptBackdrop({
  children,
  onClick,
  className = '',
  zIndex = 9999,
}) {
  if (typeof document === 'undefined') return null;

  const { className: baseClassName, style } = coLearningPromptBackdropProps;

  return createPortal(
    <div
      className={`${baseClassName} ${className}`.trim()}
      style={{ ...style, zIndex }}
      onClick={onClick}
      role="presentation"
    >
      <div
        className="mx-auto w-full max-w-md"
        onClick={(e) => e.stopPropagation()}
        role="dialog"
        aria-modal="true"
      >
        {children}
      </div>
    </div>,
    document.body
  );
}
